var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContacArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    rx: 10,
    fill: "#D9D9D9",
    fillOpacity: 0.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.4563 36.667H12.5438C12.2434 36.667 12 36.9375 12 37.2712V40.8962C12 41.2298 12.2434 41.5003 12.5438 41.5003H40.4563C40.7566 41.5003 41 41.2298 41 40.8962V37.2712C41 36.9375 40.7566 36.667 40.4563 36.667Z",
    fill: "#1A1C1B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.302 24.8253L29.661 33.3964C28.849 34.4437 27.747 35.0237 26.5 35.0559C25.3255 35.0559 24.18 34.4598 23.3535 33.3964L16.698 24.8253C16.3355 24.3581 16.2485 23.6814 16.4805 23.1014C16.7125 22.5375 17.2345 22.167 17.8 22.167H35.2037C35.7692 22.167 36.2912 22.5375 36.5232 23.1014C36.7552 23.6814 36.6682 24.3581 36.3057 24.8253H36.302Z",
    fill: "#1A1C1B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.675 12.5H24.325C23.9246 12.5 23.6 12.8607 23.6 13.3056V31.0278C23.6 31.4727 23.9246 31.8333 24.325 31.8333H28.675C29.0754 31.8333 29.4 31.4727 29.4 31.0278V13.3056C29.4 12.8607 29.0754 12.5 28.675 12.5Z",
    fill: "#1A1C1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContacArrowDown);
export default __webpack_public_path__ + "static/media/contac_arrow_down.dfcca7448148d761761a14281960251f.svg";
export { ForwardRef as ReactComponent };